import { Link } from 'react-router-dom';

import { useI18n } from '@/providers/i18n';

import styles from './CartEmpty.module.css';

export default function CartEmpty() {
  const { t } = useI18n();
  return (
    <section>
      <header className="page-h">
        <div>
          <span className="nano">/ CART / EMPTY</span>
          <h1>CART</h1>
        </div>
        <span className="meta">NO TRANSMISSIONS QUEUED</span>
      </header>
      <div className={styles.root}>
        <p className={`micro ${styles.msg}`}>SIGNAL EMPTY. NOTHING TO TRANSMIT.</p>
        <Link to="/events" className="btn btn-arrow">
          {t('label.upcoming')}
        </Link>
      </div>
    </section>
  );
}
